module.exports = __webpack_public_path__ + "media/games-1.7681ff86.mp4";